// khasConstants.js — Data & utility functions Zona KHAS
// Letakkan di: src/component/khas/khasConstants.js

// ── Provinsi ──────────────────────────────────────────────────
export const PROVINSI = [
  "Aceh","Sumatera Utara","Sumatera Barat","Riau","Kepulauan Riau","Jambi","Bengkulu",
  "Sumatera Selatan","Bangka Belitung","Lampung","Banten","DKI Jakarta","Jawa Barat",
  "Jawa Tengah","DI Yogyakarta","Jawa Timur","Bali","NTB","NTT","Kalimantan Barat",
  "Kalimantan Tengah","Kalimantan Selatan","Kalimantan Timur","Kalimantan Utara",
  "Sulawesi Utara","Sulawesi Tengah","Sulawesi Selatan","Sulawesi Tenggara",
  "Gorontalo","Sulawesi Barat","Maluku","Maluku Utara",
  "Papua","Papua Barat","Papua Selatan","Papua Tengah","Papua Pegunungan","Papua Barat Daya"
]

// ── Basis kawasan ─────────────────────────────────────────────
export const BASIS = [
  "Masjid","Destinasi Wisata","Perkantoran","Sekolah",
  "Perguruan Tinggi Negeri","Perguruan Tinggi Swasta","Perguruan Tinggi Islam",
  "Pesantren","Rumah Sakit","Fasilitas Umum (Bandara/Stasiun/Rest Area)","Pasar"
]

// ── 31 Wilayah KDEKS ─────────────────────────────────────────
export const KDEKS_WILAYAH = [
  "Aceh","Sumatera Utara","Sumatera Barat","Riau","Kepulauan Riau",
  "Jambi","Bengkulu","Sumatera Selatan","Kepulauan Bangka Belitung","Lampung",
  "Banten","DKI Jakarta","Jawa Barat","DI Yogyakarta","Jawa Tengah",
  "Jawa Timur","Kalimantan Barat","Kalimantan Tengah","Kalimantan Selatan","Kalimantan Timur",
  "Kalimantan Utara","Gorontalo","Sulawesi Utara","Sulawesi Tengah","Sulawesi Selatan",
  "Sulawesi Tenggara","Sulawesi Barat","Maluku","Maluku Utara","Papua Barat Daya","Nusa Tenggara Barat"
]

// ── Tipe kawasan (updated labels sesuai poster) ───────────────
export const TIPE_KAWASAN = [
  { value:'a1', label:'Tipe A — Kuliner Umum',     deskripsi:'Kawasan kuliner umum terbuka untuk masyarakat luas',         minTenant:10, thresholdHalal:75,  thresholdSehat:90  },
  { value:'a2', label:'Tipe A — Kuliner Terbatas', deskripsi:'Kawasan kuliner terbatas / khusus (kantin, foodcourt, dll)', minTenant:5,  thresholdHalal:75,  thresholdSehat:90  },
  { value:'b',  label:'Tipe B — Kawasan Sekolah',  deskripsi:'Kawasan kuliner di lingkungan sekolah atau pesantren',        minTenant:4,  thresholdHalal:100, thresholdSehat:100 },
]

export function getTipeConfig(tipeValue) {
  return TIPE_KAWASAN.find(t => t.value === tipeValue) || TIPE_KAWASAN[1]
}

// ── 6 Kriteria (digunakan di form checklist) ──────────────────
// Tetap 6 untuk kompatibilitas form & scoring
export const KRITERIA = [
  { t:"Area kuliner",                   d:"Area berhubungan dengan aktivitas memasak makanan/minuman & lingkungannya memenuhi kaidah halal, aman, sehat." },
  { t:"Jumlah tenant",                  d:"Tipe A Umum: min. 10 tenant · Tipe A Terbatas: min. 5 tenant · Tipe B: min. 4 tenant." },
  { t:"Fasilitas ibadah",               d:"Mushola/masjid dalam kawasan atau berjarak maks. 500 meter." },
  { t:"Memiliki Pengelola",             d:"Kawasan memiliki pengelola profesional yang bertanggung jawab atas operasional sehari-hari." },
  { t:"Sertifikat Halal, Aman & Sehat", d:"Tipe A: min. 75% sertifikasi halal BPJPH & 90% label IKL/SLHS Dinkes · Tipe B: 100%." },
  { t:"Sarana & prasarana",             d:"Memiliki sarana-prasarana pendukung: kantor pengelola, air bersih, sanitasi umum, dan perlengkapan ibadah." }
]

// ── 9 Syarat Zona KHAS (dari poster resmi KNEKS) ─────────────
export const SYARAT_ZONA_KHAS = [
  { t:"Izin Usaha & Legalitas",              d:"Memiliki izin usaha sebagai kawasan kuliner atau sejenis." },
  { t:"Pengelola Profesional",               d:"Sudah memiliki pengelola di lokasi yang profesional." },
  { t:"SDM Halal",                           d:"Mempunyai SDM Halal: penyelia halal dan manajer halal." },
  { t:"Lokasi Aman dari Najis",              d:"Lokasi proses produk halal terletak jauh dari peternakan babi." },
  { t:"Lokasi Aman dari Pencemaran",         d:"Bangunan zona KHAS terletak jauh dari area yang dapat menyebabkan pencemaran." },
  { t:"Tidak Menyajikan Makanan Non-Halal",  d:"Tidak menyajikan makanan dan minuman yang tidak halal." },
  { t:"Fasilitas Ibadah Layak",              d:"Memiliki fasilitas ibadah (tempat sholat) dilengkapi peralatan yang layak dan bersih." },
  { t:"Tidak Ada Hiburan Maksiat",           d:"Tidak menyediakan fasilitas hiburan yang mengarah pada kemaksiatan." },
  { t:"Pelaku Usaha Terdampingi",            d:"Memiliki pelaku usaha dengan usaha produktif dan bersedia dilakukan pendampingan." },
]

// ── 7 Sarana & Prasarana (dari poster resmi KNEKS) ───────────
export const SARANA_FASILITAS = [
  { t:"Kantor Pengelola",           d:"Memiliki kantor pengelola kawasan yang representatif." },
  { t:"Mushola / Masjid Terdekat",  d:"Memiliki mushola di kawasan atau dekat masjid (maks. 500 m)." },
  { t:"Air Bersih",                 d:"Tersedia sumber air bersih yang cukup untuk operasional kawasan." },
  { t:"SJPH",                       d:"Sistem Jaminan Produk Halal — tempat usaha sesuai ketentuan SJPH." },
  { t:"Higiene Sanitasi Pangan",    d:"Tempat usaha memenuhi standar Higiene Sanitasi Pangan dari Dinas Kesehatan." },
  { t:"Fasilitas Sanitasi Umum",    d:"Tersedia toilet, ruang merokok, dan tempat cuci tangan yang memadai." },
  { t:"Perlengkapan Ibadah",        d:"Tersedia tempat wudhu dan perlengkapan ibadah yang layak dan bersih." },
]

// ── Ambang Batas (updated sesuai poster) ─────────────────────
export const AMBANG_BATAS = [
  { tipe:'Tipe A — Kuliner Umum',     tenant:'Min. 10 tenant', halal:'≥ 75% Sertifikat Halal BPJPH', sehat:'≥ 90% Label IKL / SLHS Dinkes' },
  { tipe:'Tipe A — Kuliner Terbatas', tenant:'Min. 5 tenant',  halal:'≥ 75% Sertifikat Halal BPJPH', sehat:'≥ 90% Label IKL / SLHS Dinkes' },
  { tipe:'Tipe B — Kawasan Sekolah',  tenant:'Min. 4 tenant',  halal:'100% Sertifikat Halal',         sehat:'100% Aman & Sehat (IKL/SLHS)'  },
]

// ── Prosedur Penetapan (updated) ──────────────────────────────
export const PROSEDUR = [
  'Surat permohonan dan rekomendasi Zona KHAS dari inisiator',
  'Rekomendasi Direktur BIWIS KNEKS dan SK Penetapan kepada KDEKS',
]

// ── 5 Tahapan (timeline di Riwayat & Beranda) ─────────────────
export const STAGES = [
  { b:'Proses Pengajuan',                s:'Form pengajuan diisi dan dikirimkan ke sistem KNEKS.' },
  { b:'Proses Verifikasi Pengajuan',     s:'Berkas pengajuan sedang ditinjau oleh admin KNEKS.' },
  { b:'Proses Pengisian Form Penetapan', s:'Pengajuan disetujui. Melengkapi data penetapan: jumlah tenant, sertifikasi halal, dan dokumen wajib.' },
  { b:'Proses Verifikasi Penetapan',     s:'Data penetapan sedang diverifikasi oleh tim KNEKS.' },
  { b:'Penerbitan Surat Rekomendasi',    s:'Surat Rekomendasi Zona KHAS diterbitkan dan dikirimkan ke KDEKS.' },
]

// Mapping status ke tahap display index
export function statusToStageIdx(subStatus, ptStatus) {
  if (ptStatus === STATUS_PENETAPAN.SELESAI)   return 4
  if (ptStatus === STATUS_PENETAPAN.DISETUJUI) return 3
  if (ptStatus === STATUS_PENETAPAN.PROSES)    return 3
  if (subStatus === STATUS_PENGAJUAN.DISETUJUI) return 2
  if (subStatus === STATUS_PENGAJUAN.PROSES)    return 1
  return 0
}

export function statusFromTahap(t) {
  switch (t) {
    case 0:
    case 1:  return STATUS_PENGAJUAN.PROSES
    case 2:  return STATUS_PENGAJUAN.DISETUJUI
    case 3:  return STATUS_PENETAPAN.PROSES
    case 4:  return STATUS_PENETAPAN.SELESAI
    default: return STATUS_PENGAJUAN.PROSES
  }
}

// ── STATUS ────────────────────────────────────────────────────
export const STATUS_PENGAJUAN = {
  PROSES:   'Proses Verifikasi Pengajuan',
  DISETUJUI:'Pengajuan Disetujui',
  DITOLAK:  'Ditolak',
}

export const STATUS_PENETAPAN = {
  PROSES:    'Proses Verifikasi Penetapan',
  DISETUJUI: 'Penetapan Disetujui',
  SELESAI:   'Penerbitan Surat Rekomendasi',
  DITOLAK:   'Ditolak',
}

// ── CSS tag class per status ──────────────────────────────────
export function statusTagClass(status) {
  switch (status) {
    case STATUS_PENGAJUAN.PROSES:
    case STATUS_PENETAPAN.PROSES:    return 'review'
    case STATUS_PENGAJUAN.DISETUJUI:
    case STATUS_PENETAPAN.DISETUJUI: return 'setuju'
    case STATUS_PENETAPAN.SELESAI:   return 'sk'
    case STATUS_PENGAJUAN.DITOLAK:
    case STATUS_PENETAPAN.DITOLAK:   return 'tolak'
    default:                          return 'baru'
  }
}

// ── Data zona existing ────────────────────────────────────────
export const EXISTING = [
  {n:"Taman Valkenet Malabar",k:"Bandung",p:"Jawa Barat",y:2022,t:18,c:"Fasilitas Umum"},
  {n:"Lego-lego",k:"Makassar",p:"Sulawesi Selatan",y:2023,t:36,c:"Destinasi Wisata"},
  {n:"Kantin Utama ITS",k:"Surabaya",p:"Jawa Timur",y:2023,t:18,c:"Perguruan Tinggi Negeri"},
  {n:"Soto Ayam Bok Ijo Tamanan",k:"Kediri",p:"Jawa Timur",y:2023,t:11,c:"Destinasi Wisata"},
  {n:"Kantin Jawara BI",k:"Bandung",p:"Jawa Barat",y:2023,t:5,c:"Perkantoran"},
  {n:"Riau Garden",k:"Pekanbaru",p:"Riau",y:2023,t:24,c:"Destinasi Wisata"},
  {n:"Kantin Amanah RSAI",k:"Bandung",p:"Jawa Barat",y:2023,t:8,c:"Rumah Sakit"},
  {n:"Masjid Istiqlal",k:"Jakarta Pusat",p:"DKI Jakarta",y:2023,t:24,c:"Masjid"},
  {n:"Pasar Mambo",k:"Pangkal Pinang",p:"Bangka Belitung",y:2023,t:12,c:"Pasar"},
  {n:"Pusat Kuliner Kampung Ujung",k:"Labuan Bajo",p:"NTT",y:2024,t:41,c:"Destinasi Wisata"},
  {n:"Kantin SMAN 1 Slawi",k:"Tegal",p:"Jawa Tengah",y:2024,t:5,c:"Sekolah"},
  {n:"Rest Area Lebeteng",k:"Tegal",p:"Jawa Tengah",y:2024,t:20,c:"Fasilitas Umum"},
  {n:"Waduk Cacaban",k:"Tegal",p:"Jawa Tengah",y:2024,t:45,c:"Destinasi Wisata"},
  {n:"Jangkar Sandar",k:"Manado",p:"Sulawesi Utara",y:2024,t:11,c:"Destinasi Wisata"},
  {n:"Masjid Al-Alam",k:"Kendari",p:"Sulawesi Tenggara",y:2024,t:13,c:"Masjid"},
  {n:"Masjid Agung Jawa Tengah",k:"Semarang",p:"Jawa Tengah",y:2024,t:54,c:"Masjid"},
  {n:"Foodcourt UIN SUKA",k:"Sleman",p:"DI Yogyakarta",y:2024,t:8,c:"Perguruan Tinggi Islam"},
  {n:"Kantin Kampus UMP",k:"Purwokerto",p:"Jawa Tengah",y:2024,t:18,c:"Perguruan Tinggi Negeri"},
  {n:"Solo Square",k:"Solo",p:"Jawa Tengah",y:2024,t:59,c:"Fasilitas Umum"},
  {n:"Kediri Town Square",k:"Kediri",p:"Jawa Timur",y:2024,t:13,c:"Fasilitas Umum"},
  {n:"Universitas Jenderal Soedirman",k:"Purwokerto",p:"Jawa Tengah",y:2024,t:39,c:"Perguruan Tinggi Negeri"},
  {n:"Universitas Negeri Surabaya",k:"Surabaya",p:"Jawa Timur",y:2024,t:43,c:"Perguruan Tinggi Negeri"},
  {n:"Universitas Negeri Jember",k:"Jember",p:"Jawa Timur",y:2024,t:7,c:"Perguruan Tinggi Negeri"},
  {n:"RSUD Al Ihsan",k:"Kab. Bandung",p:"Jawa Barat",y:2024,t:20,c:"Rumah Sakit"},
  {n:"Titik Juara UMKM",k:"Sukabumi",p:"Jawa Barat",y:2025,t:12,c:"Fasilitas Umum"},
  {n:"Pasar PON Trenggalek",k:"Trenggalek",p:"Jawa Timur",y:2025,t:70,c:"Pasar"},
  {n:"RSUZA",k:"Banda Aceh",p:"Aceh",y:2025,t:21,c:"Rumah Sakit"},
  {n:"UIN Walisongo",k:"Semarang",p:"Jawa Tengah",y:2025,t:19,c:"Perguruan Tinggi Islam"},
  {n:"Kantin Kementerian Agama",k:"Jakarta Pusat",p:"DKI Jakarta",y:2025,t:12,c:"Perkantoran"},
  {n:"Universitas Tirta Cilegon",k:"Serang",p:"Banten",y:2025,t:10,c:"Perguruan Tinggi Negeri"},
  {n:"Ayani Megamall",k:"Pontianak",p:"Kalimantan Barat",y:2025,t:12,c:"Fasilitas Umum"},
  {n:"Wisata Kuliner Gladak Serang",k:"Probolinggo",p:"Jawa Timur",y:2025,t:10,c:"Destinasi Wisata"},
  {n:"Universitas Airlangga",k:"Surabaya",p:"Jawa Timur",y:2025,t:25,c:"Perguruan Tinggi Negeri"},
  {n:"Taman Rinjani Selong",k:"Lombok Timur",p:"NTB",y:2025,t:12,c:"Destinasi Wisata"},
  {n:"Sekolah Islam Athirah",k:"Makassar",p:"Sulawesi Selatan",y:2025,t:20,c:"Sekolah"},
  {n:"Objek Wisata Danau Perintis",k:"Gorontalo",p:"Gorontalo",y:2025,t:10,c:"Destinasi Wisata"},
  {n:"Univ Muhammadiyah Sorong",k:"Sorong",p:"Papua Barat Daya",y:2025,t:10,c:"Perguruan Tinggi Islam"},
  {n:"Kawasan Berendo Merah Putih",k:"Bengkulu",p:"Bengkulu",y:2025,t:30,c:"Fasilitas Umum"},
  {n:"UIN Raden Intan",k:"Bandar Lampung",p:"Lampung",y:2025,t:24,c:"Perguruan Tinggi Islam"},
  {n:"IPB University",k:"Bogor",p:"Jawa Barat",y:2025,t:22,c:"Perguruan Tinggi Negeri"},
  {n:"Rest Area Banjaratma",k:"Brebes",p:"Jawa Tengah",y:2024,t:52,c:"Fasilitas Umum"},
  {n:"Pasar Lebak Budi",k:"Bandar Lampung",p:"Lampung",y:2025,t:53,c:"Pasar"},
  {n:"Ponpes Sunan Drajat",k:"Lamongan",p:"Jawa Timur",y:2025,t:12,c:"Pesantren"},
  {n:"SWK Dharma Husada",k:"Surabaya",p:"Jawa Timur",y:2025,t:32,c:"Fasilitas Umum"},
]

// ── localStorage ──────────────────────────────────────────────
export const LS_KEY  = 'zonakhas_submissions_v1'
export const MAXFILE = 2 * 1024 * 1024

// ── Scoring ───────────────────────────────────────────────────
export function scoreOf(d) {
  const config   = getTipeConfig(d.tipe)
  const halalPct = d.tenant > 0 ? d.halal / d.tenant : 0
  const sehatPct = d.tenant > 0 ? d.sehat / d.tenant : 0

  const tenantOk = d.tenant >= config.minTenant
  const halalOk  = halalPct >= config.thresholdHalal / 100
  const sehatOk  = sehatPct >= config.thresholdSehat / 100

  // Tenant belum memenuhi minimum → langsung block
  if (!tenantOk) {
    return {
      pct: 0, minT: config.minTenant,
      halalPct, sehatPct,
      tenantOk: false, halalOk, sehatOk, config,
      blockReason: `Jumlah tenant belum memenuhi minimum (${config.minTenant} tenant)`,
    }
  }

  const halalScore = Math.min(1, halalPct / (config.thresholdHalal / 100))
  const sehatScore = Math.min(1, sehatPct / (config.thresholdSehat / 100))

  // Tenant sudah ok → dapat 20 poin penuh
  const s = 20 + halalScore*25 + sehatScore*20
          + (d.k2?12:0) + (d.k3?11:0) + (d.k5?12:0)

  return {
    pct: Math.round(s), minT: config.minTenant,
    halalPct, sehatPct,
    tenantOk: true, halalOk, sehatOk, config,
    blockReason: null,
  }
}

// ── Helpers ───────────────────────────────────────────────────
export function fmtDate(iso) {
  if (!iso) return '-'
  const d = new Date(iso)
  return d.toLocaleDateString('id', { day:'2-digit', month:'short', year:'numeric' })
       + ' ' + d.toLocaleTimeString('id', { hour:'2-digit', minute:'2-digit' })
}

export function fmtSize(b) {
  return b > 1048576 ? (b/1048576).toFixed(1)+' MB' : Math.max(1,Math.round(b/1024))+' KB'
}

export const fileToDataURL = (f) => new Promise((res, rej) => {
  const r = new FileReader()
  r.onload  = () => res(r.result)
  r.onerror = rej
  r.readAsDataURL(f)
})